import React from 'react';
import { useDrill } from 'contexts/DrillContext';
import type { DrillFilter } from 'contexts/DrillContext';

const DIMENSION_ICONS: Record<string, string> = {
  Employee: '\uD83D\uDC64', Engagement: '\uD83D\uDCBC', Client: '\uD83C\uDFE2',
  EngagementType: '\uD83C\uDFF7', Activity: '\u26A1', ChargeType: '\uD83D\uDCB0',
  WorkDate: '\uD83D\uDCC5', Manager: '\uD83D\uDC65', Entry: '\uD83D\uDCDD',
};

export const SyutDrillBreadcrumb: React.FC = () => {
  const { state, popTo, reset } = useDrill();
  const { breadcrumbs } = state;

  if (breadcrumbs.length === 0) return null;

  return (
    <div className="syut-drill-breadcrumb">
      <button className="drill-home-btn" onClick={() => reset()} title="Back to root level">
        🏠 Home
      </button>
      {breadcrumbs.map((b, idx) => (
        <React.Fragment key={idx}>
          <span className="drill-separator">▸</span>
          <span
            className="drill-chip"
            onClick={() => popTo(idx)}
            title={`${b.dimension}: ${b.label} — click to go back to this level`}
          >
            <span className="chip-dim">{DIMENSION_ICONS[b.dimension] || ''} {b.dimension}</span>
            {b.label.length > 24 ? b.label.substring(0, 23) + '\u2026' : b.label}
            {idx === breadcrumbs.length - 1 && (
              <span className="chip-remove" onClick={(e) => { e.stopPropagation(); popTo(idx); }} title="Remove">
                ✕
              </span>
            )}
          </span>
        </React.Fragment>
      ))}
    </div>
  );
};

export default SyutDrillBreadcrumb;
